/* tslint:disable */
/* eslint-disable */
/**
 * OneAir.AdminPortal
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface Int32IdAndLabel
 */
export interface Int32IdAndLabel {
    /**
     * 
     * @type {number}
     * @memberof Int32IdAndLabel
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof Int32IdAndLabel
     */
    label?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof Int32IdAndLabel
     */
    effective?: boolean;
}

export function Int32IdAndLabelFromJSON(json: any): Int32IdAndLabel {
    return Int32IdAndLabelFromJSONTyped(json, false);
}

export function Int32IdAndLabelFromJSONTyped(json: any, ignoreDiscriminator: boolean): Int32IdAndLabel {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'id') ? undefined : json['id'],
        'label': !exists(json, 'label') ? undefined : json['label'],
        'effective': !exists(json, 'effective') ? undefined : json['effective'],
    };
}

export function Int32IdAndLabelToJSON(value?: Int32IdAndLabel | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'label': value.label,
        'effective': value.effective,
    };
}


